import { Analytics } from '../analytics/analytics';
import { SESSION_MILESTONES } from '../config/balancing';

export class SessionMilestoneTracker {
  private readonly fired = new Set<string>();

  constructor(private readonly track: typeof Analytics.track = Analytics.track.bind(Analytics)) {}

  update(elapsedMs: number): void {
    for (const milestone of SESSION_MILESTONES) {
      if (elapsedMs >= milestone.atMs && !this.fired.has(milestone.event)) {
        this.fired.add(milestone.event);
        this.track(milestone.event);
      }
    }
  }

  hasFired(event: string): boolean {
    return this.fired.has(event);
  }
}
